<template>
  <el-dialog v-model="visibleDialog"
             :visible.sync="visibleDialog"
             @close="visibleDialog=false"
             :close-on-click-modal="false"
             :close-on-press-escape="false"
             :show-close="false"
  >
    <div class="page-box">
      <div class="decision-page">
        <!--评估-->
        <div class="task-box">
          <div class="task-top">
            <div class="manage-top">
              <div class="manage-left">
                <img src="@/assets/images/icon2.png"/>
              </div>
              <div class="manage-right">
                <div class="manage-h">飞行故障风险评估</div>
                <div class="manage-p">飞行员完成故障信息的输入，启动系统识别飞机风险源</div>
              </div>
            </div>
          </div>
          <div class="fauldetails-ul">
            <div class="fauldetails-li">
              <div class="fauldetails-head">航班信息</div>
              <div class="fauldetails-bottom">
                <div class="fauldetails-laber">
                  <div class="fauldetails-left">飞机类别</div>
                  <div class="fauldetails-right">{{ this.errorDetail.planeType }}</div>
                </div>
                <div class="fauldetails-laber">
                  <div class="fauldetails-left">航班号</div>
                  <div class="fauldetails-right">{{ this.errorDetail.flightNo }}</div>
                </div>
                <div class="fauldetails-laber">
                  <div class="fauldetails-left">飞机编号</div>
                  <div class="fauldetails-right">{{ this.errorDetail.planeId }}</div>
                </div>
              </div>
            </div>
            <div class="fauldetails-li">
              <div class="fauldetails-head">故障信息</div>
              <div class="fauldetails-bottom">
                <div class="fauldetails-laber">
                  <div class="fauldetails-left">故障照片</div>
                  <div class="fauldetails-right"><span @click="clickCarousel()">查看 ></span></div>
                </div>
                <div class="fauldetails-laber">
                  <div class="fauldetails-left">故障信息</div>
                  <div class="fauldetails-right">{{ this.errorDetail.fullFaultMessage }}</div>
                </div>
              </div>
            </div>
          </div>
          <div class="fauldetails-bt-box">
            <div class="fauldetails-bt" @click="opendialogVisible">拒绝模拟机评估申请</div>
            <div class="fauldetails-bt active" @click="socReviewR1">通过申请</div>
          </div>
          <el-dialog :visible.sync="dialogVisible" append-to-body>
            <div class="modal-box">
              <div class="modal-head">拒绝模拟机评估</div>
              <div class="modal-box1">
                <textarea placeholder="请输入拒绝理由" v-model="review.reason" :maxlength="100"></textarea>
              </div>
              <div class="modal-bt-bpx">
                <div class="modal-bt" @click="closedialogVisible">取消</div>
                <div class="modal-bt active" @click="socReviewR2">拒绝</div>
              </div>
            </div>
          </el-dialog>
        </div>
      </div>
      <Carousel v-if="carouselDialog" :showDialog="carouselDialog" @handle-close="closeCarousel" :imgs="imgs"></Carousel>
    </div>
  </el-dialog>
</template>

<script>
import {socReview, updataHandle} from "@/api/api";
import Carousel from "@/components/Carousel.vue";

export default {
  components: {Carousel},
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    dataRow: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      dialogVisible: false,
      carouselDialog: false,
      errorDetail: this.dataRow||{},
      imgs: [],
      review: {
        id: '',
        reason: "",
        socReview: '',
      },
      reson: '',
      input: '',
    }
  },
  computed: {
    visibleDialog: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      }
    },
  },
  methods: {
    clickCarousel() {
      this.imgs = this.errorDetail.errorImages ? this.errorDetail.errorImages : []
      if (this.errorDetail.errorMedia) {
        this.errorDetail.errorMedia.forEach(media => {
          this.imgs.push(media)
        })
      }
      if (this.imgs.length >= 1) {
        this.carouselDialog = true
      } else {
        this.$message.warning("暂无故障照片/信息");
      }
    },
    closeCarousel() {
      this.carouselDialog = false
    },
    opendialogVisible() {
      this.dialogVisible = true;
    },
    closedialogVisible() {
      this.dialogVisible = false;
    },
    //SOC拒绝
    async socReviewR2() {
      this.review.socReview = "R2"
      this.review.id = this.errorDetail.recordId
      const res = await socReview(this.review)
      console.log(res)
      if (res.code === 'A00000') {
        this.$message.success('提交决策成功')
        this.$emit('reject')
        // this.$router.push('/eventinitiation')
      } else {
        this.$message.error(res.message)
      }
    },
    //Soc同意，模拟机处理中
    async socReviewR1() {
      // if (this.dataRow.airports) {
      //   this.dataRow.state = "S1"
      //   const row = this.dataRow
      //   row.airports = row.airports.filter(item => item.airport !== "")
      //   await updataHandle(row)
      // }
      this.review.socReview = "R4"
      this.review.id = this.errorDetail.recordId
      const res = await socReview(this.review)
      if (res.code === 'A00000') {
        this.$message.success('提交决策成功')
        this.$emit('pass')
        // this.$router.push(`/Commitanalogdata/${this.id}`)
      } else {
        this.$message.error(res.message)
      }
    },
  }
}
</script>

<style lang="less" scoped>
  /deep/ .el-dialog__headerbtn{
    z-index: 1;
  }
/deep/ .left-box .el-dialog__wrapper {
  display: block;

  .el-dialog {
    border-radius: 0;
    background: transparent;
  }
}
.decision-page{
  padding: 0;
}
/deep/ .left-box .el-dialog {
  margin: 0 !important;
  background: #262D40;
  height: 100vh;
  width: 600px;

  .el-dialog__header {
    padding: 0;
  }

  .el-dialog__body {
    padding: 0;
    color: #fff;
  }

  .el-dialog__headerbtn .el-dialog__close {
    color: #fff;
    font-size: 20px;
  }

  .el-dialog__headerbtn {
    top: 22px;
  }
}

.history-head {
  padding: 24px 16px;
  font-size: 24px;
  text-align: left;
  line-height: 20px;
}

.history-input {
  background: #131B33;
  width: calc(100% - 32px);
  margin: auto;
  height: 45px;
  display: flex;
  align-items: center;
  border-radius: 8px;

  /deep/ .el-input__inner {
    background: none;
    color: #fff;
  }
}
.history-bottom {
  padding: 24px;

  .history-laber:last-child {
    margin-bottom: 0;
  }

  .history-laber {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 20px;

    .history-left {
      opacity: 0.87;
      font-size: 14px;
    }

    .history-right {
      opacity: 0.9;
      font-size: 16px;
    }

    .history-right.active {
      color: #E07073;
    }

    .history-right.active2 {
      color: #8EBF86;
    }

    .history-right.active3 {
      color: #EBA967;
    }

    .history-right.active4 {
      color: #2769EC;
    }
  }
}

.history-ul {
  padding: 16px;
  border-top: 1px solid #171E2F;
  margin-top: 20px;
  height: calc(100vh - 136px);
  padding-bottom: 0;
  box-sizing: border-box;
  overflow: auto;

  .history-li {
    background: #393F52;
    border: 1px solid #525F89;
    border-radius: 16px;
    margin-bottom: 16px;

    .history-top {
      display: flex;
      padding: 24px;
      justify-content: space-between;
      border-bottom: 1px solid #000000;

      .history-text {
        text-align: left;
        width: 370px;

        .history-h {
          font-size: 16px;
          color: rgba(255, 255, 255, 0.87);
          margin-bottom: 10px;
        }

        .history-p {
          color: rgba(255, 255, 255, 0.7);
          font-size: 12px;
        }
      }

      .history-bt {
        background: #4E5569;
        border-radius: 8px;
        font-size: 14px;
        cursor: pointer;
        padding: 0 20px;
        height: 34px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Commitanalogdata/components/ConfirmDialog.vue